import { Container } from "reactstrap"
import styles from './Overview.module.scss'
import AdvertisingOptions from './AdvertisingOptions/AdvertisingOptions'
import AdvertisingBenefits from "./AdvertisingBenefits/AdvertisingBenefits"
import Resources from "./Resources/Resources"

const Overview = () => {
  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Advertisement Overview</h4>

        <div className="px-3">
          <div className={styles['header']}>
            Welcome to the Advertisement Page. Explore the advertising opportunities available to promote your products and brands effectively on our platform.
          </div>

          <AdvertisingOptions />

          <AdvertisingBenefits />

          <Resources />
        </div>
      </Container>
    </div>
  )
}

export default Overview